import React, {ChangeEvent, FC, useEffect, useRef, useState} from 'react';
import {useFormik} from 'formik';
import './style.css';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {ReactComponent as SelectArrayIcon} from '../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIcon} from '../../assets/i/arrow-up-icon.svg';
import {ReactComponent as LinkIcon} from '../../assets/form/link.svg';
import {Options} from './options/options';
import {useAppDispatch, useAppSelector} from 'common/hook';
import {ReactComponent as CalendarIcon} from '../../assets/main/groups/main-table/period-calendar/calendar.svg';
import {DatePicker, Input, message, Select} from 'antd';
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {setEditProfileAC} from "app/popups-reducer";
import {ROLE_DEMO_STUDENT, ROLE_STUDENT} from "entities/constants/constants";
import {fetchEditProfile} from "features/model/service/feach-edit-profile/feachEditProfile";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {clearEditProfileErrors} from "features/model/slice/editProfileSlice";

dayjs.extend(customParseFormat);


export interface EditProfileFormValues {
    firstName: string;
    lastName: string;
    phone: string;
    additionalPhone: string;
    email: string;
    birthDate: string | null;
    timeZone: string;
    country: string;
    address: string;
    currency: string;
    vk: string;
    telegram: string;
    viber: string;
    whatsapp: string;
    instagram: string;
    facebook: string;
}

export const FormEditProfile: FC = () => {
    dayjs.locale('ru');
    const dispatch = useAppDispatch();
    const {errors, error, success} = useAppSelector(state => state.editProfile);


    const {
        isFilled,
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false, false]);

    const successMessage = () => {
        message.success('Информация успешно изменена');
    };


    const roleType = useAppSelector((state) => state.role.roleType);
    const profileData = useAppSelector((state) => state.profile.data);


    const [openOne, setOpenOne] = useState<boolean>(false);
    const [openTwo, setOpenTwo] = useState<boolean>(false);
    const [openThree, setOpenThree] = useState<boolean>(false);


    const [selectedDate, setSelectedDate] = useState<string | null>(
        profileData?.birthDate || null
    );

    const countriesFilter = profileData?.countries
        .filter((el) => el.title === profileData?.country)
        .map((el) => el.code)
        .join('');

    // Options
    const timeZonesOptions: Options[] = profileData?.timeZones.map(zone => ({
        value: zone.value,
        label: zone.label,
    })) || [];

    const countriesOptions: Options[] = profileData?.countries.map(country => ({
        value: country.code,
        label: country.title,
    })) || [];

    const currenciesOptions: Options[] = profileData?.currencies.map(currencies => ({
        value: currencies.value,
        label: currencies.label,
    })) || [];

    const onClickHandler = () => {
        dispatch(setEditProfileAC(false));
    };

    useEffect(() => {
        if (success) {
            onClickHandler();
            successMessage();
            dispatch(clearEditProfileErrors({success: false, error: '', errors: {}}))
        }
    }, [success]);

    const OnClickAvailableHandler = () => {
        setOpenOne(!openOne)
    }
    const OnClickGroupsHandler = () => {
        setOpenTwo(!openTwo)
    }
    const OnClickCurrencyHandler = () => {
        setOpenThree(!openThree)
    }


    const handleMobilePhoneInput = (event: ChangeEvent<HTMLInputElement>) => {
        const {value} = event.target;
        event.target.value = value.replace(/[^0-9+()-]/g, "");
    };

    const formRef = useRef<HTMLFormElement>(null);


    const handleOutsideClick = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const isInsidePopup = target.closest('.popup.form-popup');
        if (!formRef.current?.contains(target) && !isInsidePopup) {
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);


    const handleCountryChange = (value: string) => {
        handleChange('country', value);
    };

    const handleSubmit = async () => {
        const updatedValues = {
            ...formik.values,
            birthDate: selectedDate,
        };
        try {
            await dispatch(fetchEditProfile(updatedValues));

        } catch (error) {
            console.error('Произошла ошибка при отправке данных:', error);
        }
    };


    const formik = useFormik<EditProfileFormValues>({
        initialValues: {
            firstName: profileData?.firstName || '',
            lastName: profileData?.lastName || '',
            phone: profileData?.phone || '',
            additionalPhone: profileData?.additionalPhone || '',
            email: profileData?.email || '',
            birthDate: profileData?.birthDate || '',
            timeZone: profileData?.timeZone || '',
            country: countriesFilter || '',
            address: profileData?.address || '',
            currency: profileData?.currency || '',
            vk: profileData?.socials[0].link || '',
            telegram: profileData?.socials[1].link || '',
            viber: profileData?.socials[2].link || '',
            whatsapp: profileData?.socials[3].link || '',
            instagram: profileData?.socials[4].link || '',
            facebook: profileData?.socials[5].link || '',
        },
        enableReinitialize: true,
        onSubmit: handleSubmit,
    });


    const handleChange = (name: string, value: string) => {
        formik.setFieldValue(name, value);
    };


    return (
        <>
            <p className="h3 popup-title">Редактировать профиль</p>
            <form
                id="edit-profile-popup"
                ref={formRef}
                onSubmit={formik.handleSubmit}
                className="form">
                <div className="fields-row">
                    <div
                        className={`field has-icon-inp ${isFilled[0] ? 'filled' : ''} ${errors?.firstName ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.firstName ? 'active-label' : ''}`}>Имя*</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control input-disabled"
                                name="firstName"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                readOnly
                            />
                        </div>
                        {errors?.firstName && <p className="field-error">{errors?.firstName}</p>}
                    </div>
                </div>

                <div className="fields-row">
                    <div
                        className={`field has-icon-inp ${isFilled[1] ? 'filled' : ''} ${errors?.lastName ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.lastName ? 'active-label' : ''}`}>Фамилия*</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control input-disabled"
                                name="lastName"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(1)}
                                onBlur={handleBlur}
                                readOnly
                            />
                        </div>
                        {errors?.firstName && <p className="field-error">{errors?.lastName}</p>}
                    </div>
                </div>

                <div style={{cursor: 'pointer'}} className="fields-row">
                    <div
                        className={`field has-icon-inp ${selectedDate || formik.values.birthDate ? 'filled' : ''} ${errors?.birthDate ? 'error-field' : ''}`}>
                        <label className={`field-name ${selectedDate ? 'active-label' : ''}`}>Дата рождения*</label>
                        <div className="inp-box">
                            <DatePicker
                                style={{cursor: 'pointer', caretColor: 'transparent', overflow: 'visible'}}
                                className="form-control"
                                name="birthDate"
                                onChange={(date, dateString) => {
                                    setSelectedDate(dateString as string);
                                }}
                                value={selectedDate ? dayjs(selectedDate, 'DD-MM-YYYY') : null}
                                onFocus={() => handleFocus(14)}
                                onBlur={handleBlur}
                                autoComplete="off"
                                placeholder=""
                                status={`${errors?.birthDate ? 'error' : ''}`}
                                inputReadOnly={true}
                                suffixIcon={<span className="icon-date"><CalendarIcon/></span>}
                                format="DD-MM-YYYY"
                            />
                        </div>
                        {errors?.birthDate && <p className="field-error">{errors?.birthDate}</p>}
                    </div>
                </div>

                <div className="fields-row">
                    <div
                        className={`field required ${isFilled[3] ? 'filled' : ''} ${errors?.email ? 'error-field' : ''} ${errors?.email ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.email ? 'active-label' : ''}`}>Email</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(3)}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors?.email && <p className="field-error">{errors?.email}</p>}
                    </div>
                </div>

                <div className="fields-row">
                    <div
                        className={`field required ${errors?.phone ? 'error-field' : ''} ${errors?.phone ? 'error-field' : ''}`}>
                        <label className="field-name active-label">Мобильный телефон</label>
                        <div className="inp-box">
                            <Input
                                className="form-control"
                                type="tel"
                                name="phone"
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(4)}
                                onBlur={handleBlur}
                                onInput={handleMobilePhoneInput}
                                placeholder="+375(XX)XXX-XX-XX"
                            />
                        </div>
                        {errors?.phone && <p className="field-error">{errors?.phone}</p>}
                    </div>
                </div>

                {(roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT) && (
                    <div className="field required">
                        <label className="field-name active-label">Дополнительный телефон</label>
                        <div className="inp-box">
                            <Input
                                className="form-control"
                                type="tel"
                                name="additionalPhone"
                                value={formik.values.additionalPhone}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(4)}
                                onBlur={handleBlur}
                                pattern="[0-9+]*"
                                onInput={handleMobilePhoneInput}
                                placeholder="+375(XX)XXX-XX-XX"
                            />
                        </div>
                    </div>
                )}

                <div className="fields-row gap">
                    <div className={`course-type ${errors?.timeZone ? 'error-field' : ''}`}
                         onClick={OnClickAvailableHandler}>
                        <span
                            className={`${errors?.timeZone ? 'error-label-select' : ''} ${formik.values.timeZone ? 'active-label' : ''}`}>Временная зона</span>
                        <Select
                            style={{width: '100%'}}
                            value={formik.values.timeZone}
                            options={timeZonesOptions}
                            onFocus={() => handleFocus(5)}
                            onBlur={handleBlur}
                            status={`${errors?.timeZone ? 'error' : ''}`}
                            onChange={(value) => handleChange('timeZone', value)}
                            suffixIcon={openOne ? <ArrowUpIcon/> : <SelectArrayIcon/>}
                        />
                        {errors?.timeZone && <p className="field-error">{errors?.timeZone}</p>}
                    </div>
                    <div className="course-type" onClick={OnClickGroupsHandler}>
                        <span className={formik.values.country ? 'active-label' : ''}>Страна</span>
                        <Select
                            style={{width: '100%'}}
                            value={formik.values.country}
                            options={countriesOptions}
                            onFocus={() => handleFocus(6)}
                            onBlur={handleBlur}
                            status={`${errors?.country ? 'error' : ''}`}
                            onChange={handleCountryChange}
                            suffixIcon={openTwo ? <ArrowUpIcon/> : <SelectArrayIcon/>}
                        />
                    </div>
                </div>

                <div className="fields-row">
                    <div className={`field ${isFilled[7] ? 'filled' : ''} ${errors?.address ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.address ? 'active-label' : ''}`}>Адрес</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="address"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(7)}
                                onBlur={handleBlur}
                            />
                        </div>
                        {errors?.address && <p className="field-error">{errors?.address}</p>}
                    </div>
                </div>

                {(roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT) && (
                    <div className="course-type" onClick={OnClickCurrencyHandler}>
                        <span className={formik.values.currency ? 'active-label' : ''}>Валюта</span>
                        <Select
                            style={{width: '100%'}}
                            value={formik.values.currency}
                            options={currenciesOptions}
                            onFocus={() => handleFocus(5)}
                            onBlur={handleBlur}
                            status={`${errors?.currency ? 'error' : ''}`}
                            onChange={(value) => handleChange('currency', value)}
                            disabled={true}
                        />
                    </div>
                )}

                <div className="fields-row">
                    <div className={`field ${isFilled[8] ? 'filled' : ''}`}>
                        <label className={`field-name ${formik.values.facebook ? 'active-label' : ''}`}>Facebook</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="facebook"
                                value={formik.values.facebook}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(8)}
                                onBlur={handleBlur}
                            />
                            <div className='input-icon'>
                                <LinkIcon/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[9] ? 'filled' : ''} ${errors?.vk ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.vk ? 'active-label' : ''}`}>VKontakte</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="vk"
                                value={formik.values.vk}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(9)}
                                onBlur={handleBlur}
                            />
                            <div className='input-icon'>
                                <LinkIcon/>
                            </div>
                        </div>
                        {errors?.vk && <p className="field-error">{errors?.vk}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[10] ? 'filled' : ''} ${errors?.instagram ? 'error-field' : ''}`}>
                        <label
                            className={`field-name ${formik.values.instagram ? 'active-label' : ''}`}>Instagram</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="instagram"
                                value={formik.values.instagram}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(10)}
                                onBlur={handleBlur}
                            />
                            <div className='input-icon'>
                                <LinkIcon/>
                            </div>
                        </div>
                        {errors?.instagram && <p className="field-error">{errors?.instagram}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[11] ? 'filled' : ''} ${errors?.viber ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.viber ? 'active-label' : ''}`}>Viber</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="viber"
                                value={formik.values.viber}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(11)}
                                onBlur={handleBlur}
                            />
                            <div className='input-icon'>
                                <LinkIcon/>
                            </div>
                        </div>
                        {errors?.viber && <p className="field-error">{errors?.viber}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[12] ? 'filled' : ''} ${errors?.telegram ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.telegram ? 'active-label' : ''}`}>Telegram</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="telegram"
                                value={formik.values.telegram}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(12)}
                                onBlur={handleBlur}
                            />
                            <div className='input-icon'>
                                <LinkIcon/>
                            </div>
                        </div>
                        {errors?.telegram && <p className="field-error">{errors?.telegram}</p>}
                    </div>
                </div>
                <div className="fields-row">
                    <div className={`field ${isFilled[13] ? 'filled' : ''} ${errors?.whatsapp ? 'error-field' : ''}`}>
                        <label className={`field-name ${formik.values.whatsapp ? 'active-label' : ''}`}>Whatsapp</label>
                        <div className="inp-box">
                            <input
                                type="text"
                                className="form-control"
                                name="whatsapp"
                                value={formik.values.whatsapp}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(13)}
                                onBlur={handleBlur}
                            />
                            <div className='input-icon'>
                                <LinkIcon/>
                            </div>
                        </div>
                        {errors?.whatsapp && <p className="field-error">{errors?.whatsapp}</p>}
                    </div>
                </div>
                <button type="submit" className="btn full-width">
                    <span>Сохранить</span>
                </button>
            </form>
            <span className="js-close-popup" onClick={onClickHandler}>
                <CloseIcon/>
            </span>
        </>
    );
};
